<template>
  <div class="header" style="height:65px; background-image: linear-gradient(to left, #4682B4, rgb(68,68,68)); border-color: rgb(68,68,68)">
    <div class="container-fluid">
      <div class="header-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'base-header',
    props: {
      type: {
        type: String,
        default: 'success',
        description: 'Header background type'
      }
    }
  }
</script>
<style>
</style>
